import React, { Component } from 'react';
import Select from 'react-select';
import { AddRevenue } from '../../Redux/action/revenueAction';
import { toast } from 'react-toastify';
import {
  allLocationWithShortName,
  dataLocation,
  dataUser,
  spocLocationDetailsZoho,
} from '../Helpers/util';
import './form.css';
import moment from 'moment';
import axios from 'axios';
import { getLocationNameById } from '../../utils/getLocationNameById';
import SwTextArea from '../Common/FormComponent/SwTextArea';
import SwCheckbox from '../Common/FormComponent/SwCheckbox';
import SwSelect from '../Common/SwReactSelect/SwReactSelect';
import AntDDatePicker from '../Common/AntDDateTimePicker/AntDDatePicker';

import dayjs from 'dayjs';

const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
const userDataLocal1 = dataLocation();
var LocationObj = JSON.parse(userDataLocal1);
const userDataLocal12 = spocLocationDetailsZoho();
const locationWithShortName = allLocationWithShortName();

class Other extends Component {
  constructor(props) {
    super(props);
    this.state = {
      company_id: UserObj ? UserObj.company_id : null,
      spocid: UserObj ? UserObj.rec_id : null,
      email: UserObj ? UserObj.email : '',
      notes: '',
      locationSpoc: [],
      location: '',
      location1: '',
      locationError: '',
      notesError: '',
      locationData: [],
      locationNew: [],
      locationId: null,
      start_date: '',
      typeOfItem: [],
      startDateError: '',
      typeOfItemError: '',
      files: null,
      attachmentError: '',
      btnStatus: false,
      selectedFile: undefined,
      selectedFileName: undefined,
      imageSrc: undefined,
      value: '',
    };
  }

  componentDidMount() {
    var LocationSpoc = JSON.parse(userDataLocal12);
    let locationShort = JSON.parse(locationWithShortName);
    this.setState({ locationNew: locationShort });
    this.setState({
      locationData: LocationSpoc,
    });
  }

  changeSelect = e => {
    if (!e) {
      this.setState({
        location: null,
        location1: '',
        locationId: '',
        locationError: '',
      });
      return;
    }

    this.setState({
      location: e,
      location1: String(e.label),
      locationId: e.value,
      locationError: '',
    });
  };

  onNotes = e => {
    this.setState({
      notes: e?.target?.value,
      notesError: '',
    });
  };
  resetValue = () => {
    this.setState({
      location: '',
      notes: '',
      locationError: '',
      notesError: '',
      start_date: '',
      typeOfItem: '',
      attachmentError: '',
    });
    this.setState({
      selectedFile: undefined,
      selectedFileName: undefined,
      imageSrc: undefined,
      value: '',
    });
  };

  onLocation = e => {
    this.setState({
      location: e?.target?.value,
      location1: String(e.value),
      locationError: '',
    });
  };
  handleCheckboxChange = event => {
    const { value, checked } = event.target;
    this.setState(prevState => {
      const updatedServices = checked
        ? [...prevState.typeOfItem, value]
        : prevState.typeOfItem.filter(service => service !== value);

      return { typeOfItem: updatedServices };
    });
  };

  handleFile(e) {
    if (e.target.files[0]) {
      this.setState({
        selectedFile: e.target.files[0],
        selectedFileName: e.target.files[0].name,
        imageSrc: window.URL.createObjectURL(e.target.files[0]),
        value: e.target.value,
      });
    }

    this.setState({ files: e.target.files });

    if (e.target.files.length > 2) {
      this.setState({ attachmentError: "Attachment can't be more than 2" });
    } else if (e.target.files.length <= 2) {
      this.setState({ attachmentError: '' });
    }
  }

  handleSubmit = e => {
    e.preventDefault();
    const { start_date, typeOfItem } = this.state;
    let files = this.state.files;
    let formData = new FormData();

    // Append files to FormData
    if (files && files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        formData.append('file', files[i]);
      }
    }

    // Validation checks
    if (this.state.location === null || this.state.location === '') {
      this.setState({ locationError: "Location can't be empty" });
    } else if (!start_date) {
      this.setState({ startDateError: 'Start date can not be empty' });
    } else if (!typeOfItem.length) {
      toast.error('Type Of item can not be empty');
    } else if (this.state.files != null && this.state.files.length > 2) {
      this.setState({ attachmentError: "Attachment can't be more than 2" });
    } else {
      e.currentTarget.disabled = true;

      // Concatenate typeOfItem array into a single string
      const concatenatedItems = typeOfItem.join(', ');

      let param = {};
      let common_param = {
        company_id: this.state.company_id,
        spoc_id: this.state.spocid,
        email: this.state.email,
        company_name: UserObj.company_name,
        category: 'pantry_stationary_items',
      };
      let body_param = {
        location_name: this.state.location1,
        start_date: start_date,
        type_of_item: concatenatedItems, // Use concatenated string
        notes: this.state.notes,
      };
      param.common_param = common_param;
      param.body_param = body_param;

      // AddRevenue(param, this.props.onClose)
      //   .then(() => {
      //     // success handled by onClose
      //     this.setState({ btnStatus: false });
      //     e.currentTarget.disabled = false;
      //   })
      //   .catch(() => {
      //     // error toast already shown in AddRevenue
      //     this.setState({ btnStatus: false });
      //     e.currentTarget.disabled = false;
      //   });
      // e.currentTarget.disabled = false;
      AddRevenue(param, (success, message) => {
        if (success) {
          toast.success(message);
          this.resetValue();
          if (this.props.onClose) {
            this.props.onClose();
          }
        }
        this.setState({ btnStatus: false });
        e.currentTarget.disabled = false;
      })
    }
  };
  render() {
    const selectLocationData = [];
    if (this.state.locationSpoc && this.state.locationSpoc.length > 0) {
      this.state.locationSpoc.map(item => {
        if (item.rec_id) {
          selectLocationData.push({
            value: item['location_name_zoho'],
            label: item['location_name_zoho'],
          });
        }
      });
    }
    return (
      <>
        {' '}
        <div className="row">
          {' '}
          <div className="col-md-12">
            <div className="SwFormGroup">
              {' '}
              <label className="SwFormLabel">
                Location <span className="Required">*</span>
              </label>{' '}
              <SwSelect
                name="location"
                id="pantry-location-select"
                onChange={this.changeSelect}
                value={this.state.location}
                options={this.state.locationData}
                isClearable={false}
              />
              <span className="SwTextDanger SwTextSmall">{this.state.locationError}</span>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 col-xl-12 col-lg-12">
            <div className="col-md-12">
              {' '}
              <div className="SwFormGroup">
                <label className="SwFormLabel">
                  Start Date <span className="Required">*</span>
                </label>{' '}
                <AntDDatePicker
                  value={
                    this.state.start_date
                      ? dayjs(this.state.start_date, 'YYYY-MM-DD')
                      : null
                  }
                  format="DD/MM/YYYY"
                  placeholder="Select start date"
                  disabledDate={(current) =>
                    current && current.isBefore(dayjs().startOf('day'))
                  }
                  onChange={(date) => {
                    this.setState({
                      start_date: date ? date.format('YYYY-MM-DD') : '',
                      startDateError: '',
                    });
                  }}
                  allowClear={false}
                />

                <span className="SwTextDanger SwTextSmall">{this.state.startDateError}</span>
              </div>
            </div>{' '}
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="col-md-12">
              <div className="SwFormGroup">
                <label className="SwFormLabel">
                  Type <span className="Required">*</span>
                </label>
                <SwCheckbox
                  id="pantry-type-checkbox1"
                  name="typeOfItem"
                  label="Stationary"
                  value="Stationary"
                  checked={this.state.typeOfItem.includes('Stationary')}
                  onChange={this.handleCheckboxChange}
                />
                <SwCheckbox
                  id="pantry-type-checkbox2"
                  name="typeOfItem"
                  label="Toiletry"
                  value="Toiletry"
                  checked={this.state.typeOfItem.includes('Toiletry')}
                  onChange={this.handleCheckboxChange}
                />
                <SwCheckbox
                  id="pantry-type-checkbox3"
                  name="typeOfItem"
                  label="Pantry"
                  value="Pantry"
                  checked={this.state.typeOfItem.includes('Pantry')}
                  onChange={this.handleCheckboxChange}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 mt-2">
            <div className="col-md-12">
              <div className="SwFormGroup">
                {' '}
                <label className="SwFormLabel">Notes</label>{' '}
                <SwTextArea
                  id="pantry-notes"
                  rows="4"
                  value={this.state.notes}
                  onChange={this.onNotes}
                />{' '}
                <span className="SwTextDanger SwTextSmall">{this.state.notesError}</span>
              </div>
            </div>{' '}
          </div>{' '}
        </div>
      </>
    );
  }
}

export default Other;
